export function generateSlug(title: string): string {
    const slug = title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "") // remove non-alphanumeric
        .replace(/\s+/g, "-")         // spaces → dashes
        .replace(/-+/g, "-");         // collapse multiple dashes

    // enforce WordPress slug limit (200 chars), keep some buffer
    return slug.substring(0, 190);
}

export function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}


export function unixToDateString(unixTime: number): string {
    // if unixTime is in seconds, multiply to ms
    const ms = unixTime < 1e12 ? unixTime * 1000 : unixTime;
    const date = new Date(ms);

    // format as YYYY-MM-DD
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
}
